
import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AutenticacionService, ModulosARK, TipoPermiso } from '../../services/autenticacion.service';
import { ReportesService } from '../../services/reportes.service';
import { HelpersService } from '../../services/tools/helpers.service';
import { SecurityModalComponent } from '../partials/security-modal/security-modal.component';


@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.scss']
})
export class CatalogoReportesComponent implements OnInit {

  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;

  public permisosReportes = {
    CuentasPorCobrar: false,
    CuentasPorPagar: false,
    ResumenDeObra: false,
    PorInversionista: false,
    BalanceKr: false,
    PuntoDeEquilibrio: false,
    PorObra: false,
    ResumenDeDiferencia: false,
    Saldos: false,
    DepositoGarantia: false,
    ReporteCobranza: false,
    CarpetaBlanca: false,
    EstadoCuentaClientes: false
  };

  // Modo sobre (users.key === 1). Cuando esta prendido se muestra la tarjeta
  // Carpeta Blanca y, en general, los modulos pueden mostrar contenido extra.
  public securityActived: boolean = false;

  constructor( private sanitizer: DomSanitizer,
    private authService: AutenticacionService,
    private reportesService: ReportesService,
    private helperService: HelpersService) {
    // se colocó esto para que el this dentro de delete sea el del scope global
  }
  ngOnInit() {
    this.permisosReportes.CuentasPorCobrar = this.authService.tienenPermisos(ModulosARK.ReporteCuentasPorCobrar, TipoPermiso.Lectura);
    this.permisosReportes.CuentasPorPagar = this.authService.tienenPermisos(ModulosARK.ReporteCuentasPorPagar, TipoPermiso.Lectura);
    this.permisosReportes.ResumenDeObra = this.authService.tienenPermisos(ModulosARK.ReporteResumenDeObra, TipoPermiso.Lectura);
    this.permisosReportes.PorInversionista = this.authService.tienenPermisos(ModulosARK.ReportePorInversionista, TipoPermiso.Lectura);
    this.permisosReportes.BalanceKr = this.authService.tienenPermisos(ModulosARK.ReporteBalanceKr, TipoPermiso.Lectura);
    this.permisosReportes.PuntoDeEquilibrio = this.authService.tienenPermisos(ModulosARK.ReportePuntoDeEquilibrio, TipoPermiso.Lectura);
    this.permisosReportes.PorObra = this.authService.tienenPermisos(ModulosARK.ReportePorObra, TipoPermiso.Lectura);
    this.permisosReportes.ResumenDeDiferencia = this.authService.tienenPermisos(ModulosARK.ReporteResumenDeDiferencia, TipoPermiso.Lectura);
    this.permisosReportes.Saldos = this.authService.tienenPermisos(ModulosARK.ReporteSaldos, TipoPermiso.Lectura);
    this.permisosReportes.DepositoGarantia = this.authService.tienenPermisos(ModulosARK.ReporteDepositoGarantia, TipoPermiso.Lectura);
    this.permisosReportes.ReporteCobranza = this.authService.tienenPermisos(ModulosARK.ReporteCobranza, TipoPermiso.Lectura);
    this.permisosReportes.CarpetaBlanca = this.authService.tienenPermisos(ModulosARK.CarpetaBlanca, TipoPermiso.Lectura);
    this.permisosReportes.EstadoCuentaClientes = this.authService.tienenPermisos(ModulosARK.EstadoCuentaClientes, TipoPermiso.Lectura);

    // Estado inicial del modo sobre tomado del auth_user (puede ya venir prendido).
    this.securityActived = !!(this.authService.auth_user && Number(this.authService.auth_user.key) === 1);
  }

  // === Modo sobre (sobresito) ===

  canSecurity() {
    return this.reportesService.canSecurity();
  }

  /** Click en el icono sobre. Si esta apagado, abre modal de password. Si esta prendido, lo apaga. */
  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          if (respuesta && respuesta.success) {
            this.securityActived = false;
            if (this.authService.auth_user) {
              this.authService.auth_user.key = 0;
            }
            this.securityModal.push({ 'passwordActivated': false });
          }
        });
    }
  }

  /** Callback del modal de seguridad: valida la password y prende el modo sobre. */
  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.reportesService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if (respuesta && respuesta.success === true) {
          this.securityActived = true;
          if (this.authService.auth_user) {
            this.authService.auth_user.key = 1;
          }
          this.securityModal.push({ 'passwordActivated': true });
          this.securityModal.close();
        }
      }, (error) => {
        this.securityModal.loading = false;
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
        this.securityActived = false;
        this.securityModal.push({ 'passwordActivated': false });
      });
  }

  
}



// WEBPACK FOOTER //
// ./src/app/components/reportes/reportes.component.ts